'use strict';
const Backbone = require('backbone');
const Version = require('data/domain/entity/content/version');

module.exports = Backbone.Collection.extend({
    model: Version,
    modelId: function(attrs) {
        if (attrs._content === undefined || attrs.id === undefined) {
            return undefined;
        }
        return `DataContent:${attrs._content.id}/Version:${attrs.id}`;
    },

    comparator: function(child) {
        return - child.getUpdatedAt();
    }
});



// WEBPACK FOOTER //
// ./data/domain/collection/content/version.js